import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import TechnologistOrderDocumentTypeConfig from '@/models/interfaces/TechnologistOrderDocumentType';

export default class TechnologistOrderDocumentTypeAPI {
    public static async getAll() {
        let documentTypes;
        try {
            documentTypes = await ApiController.get(ApiRoutes.technologistOrderDocumentType.get) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(documentTypes);
    }

    public static async getById(id: string) {
        let documentType;
        try {
            documentType = await ApiController.get(ApiRoutes.technologistOrderDocumentType.getById(id)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(documentType);
    }

    public static async update(id: string, info: TechnologistOrderDocumentTypeConfig) {
        let documentType;
        const request = {
            data: {
                type: 'technologist_order_document_types',
                id,
                attributes: {},
            },
        };

        if (info.name) {
            // @ts-ignore
            request.data.attributes.name = info.name;
        }

        if (info.code) {
            // @ts-ignore
            request.data.attributes.code = info.code;
        }

        try {
            documentType = await ApiController.patch(
                ApiRoutes.technologistOrderDocumentType.update(id),
                request,
            ) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(documentType);
    }

    public static async delete(id: string) {
        try {
            await ApiController.delete(ApiRoutes.technologistOrderDocumentType.delete(id));
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve();
    }

    public static async create(info: TechnologistOrderDocumentTypeConfig) {
        let documentType;
        const request = {
            data: {
                type: 'technologist_order_document_types',
                attributes: {
                    name: info.name,
                    code: info.code,
                },
            },
        };

        try {
            documentType = await ApiController.post(
                ApiRoutes.technologistOrderDocumentType.create,
                request,
            ) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(documentType);
    }
}